



































import { Component, Prop, Vue } from 'vue-property-decorator';

import { Typography, Picture } from '@/components/atoms';
import CloseIcon from '@/components/icons/Close.vue';
import CheckIcon from '@/components/icons/Check.vue';

@Component({
  components: {
    Typography,
    CloseIcon,
    CheckIcon,
    Picture
  }
})
export default class CategoryItem extends Vue {
  @Prop({ default: '' }) readonly name!: string;
  @Prop({ default: '' }) readonly icon?: string;
  @Prop({ default: false }) readonly active?: boolean;
  @Prop({ default: false }) readonly disabled?: boolean;
  @Prop({ default: false }) readonly isTextField?: boolean;
  @Prop({ default: false }) readonly hasError?: boolean;
  @Prop({ default: false }) readonly focusedInput?: boolean;

  iconMap: Record<string, string> = {
    'Arts & Entertainment': 'arts',
    'Beauty & Personal Care': 'beauty',
    'Food & Drink': 'food',
    'Health & Fitness': 'health',
    'Shopping & Retail': 'shopping',
    'Sports & Recreation': 'sports',
    Pets: 'pets',
    Education: 'education',
    Other: 'other',
    Others: 'other'
  };

  get categoryImage() {
    return require(`@/assets/img/business-onboarding/category/${
      this.iconMap[this.icon || '']
    }.png`);
  }
}
